import { lazy, Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from "./Components/ErrorBoundary";
import Loading from "./Components/Loading";

const HomePage = lazy(() => import("./Routes/HomePage/HomePage"));
const Applications = lazy(() => import("./Routes/ApplicationsPage/Applications/Applications"));
const Services = lazy(() => import("./Routes/Services/Service"));
const NotFound = lazy(() => import("./Routes/NotFound/NotFound"));

const routeDefinitions = createRoutesFromElements(
  <Route>
    <Route path='/' element={<HomePage />} />
    <Route path='applications' element={<Applications />} />
    <Route path='services' element={<Services />} />
    <Route path='*' element={<NotFound />} />
  </Route>
);

const router = createBrowserRouter(routeDefinitions);

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <Suspense fallback={<Loading />}>
          <RouterProvider router={router} />
        </Suspense>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
